import { gql } from 'graphql-tag'

export const CurrentUser = gql`
  query CurrentUser {
    me {
      id
      first_name
      last_name
      full_name
      email
      preferred_lang
      is_admin
      is_site_manager
      is_contractor
      active_managing_sites {
        id
        name
      }
      active_managing_site {
        id
        name
      }
      managing_sites {
        id
        name
      }
      inductions {
        id
        year
        completed_at
        on_site_training_done
        site {
          id
          name
          address
        }
      }
    }
  }
`

export const GetContractorProfile = gql`
  query GetContractorProfile($id: ID!) {
    user(id: $id) {
      id
      first_name
      last_name
      full_name
      email
      date_of_birth
      companies {
        id
        name
      }
      inductions {
        id
        on_site_training_done
        completed_at
        site {
          id
          name
        }
      }
    }
  }
`

export const GetManagerProfile = gql`
  query GetManagerProfile($id: ID!) {
    user(id: $id) {
      id
      first_name
      last_name
      full_name
      email
      active_managing_sites {
        id
        name
      }
      managing_sites {
        id
        name
        created_at
      }
    }
  }
`

export const GlobalSearchContractor = gql`
  query SearchbarContractors($search: String, $page: Int!) {
    contractors(search: $search, page: $page) {
      data {
        id
        first_name
        last_name
        full_name
        is_contractor
        companies {
          name
        }
        inductions {
          completed_at
          on_site_training_done
          site {
            name
          }
        }
      }
    }
  }
`

export const SearchManagers = gql`
  query SearchManagers($search: String, $page: Int!) {
    siteManagers(search: $search, page: $page) {
      data {
        id
        first_name
        last_name
        full_name
        active_managing_sites {
          id
          name
        }
      }
      paginatorInfo {
        currentPage
        lastPage
        hasMorePages
      }
    }
  }
`

export const SearchContractor = gql`
  query SearchInputContractors($search: String, $page: Int = 1, $first: Int = 50) {
    contractors(search: $search, page: $page, first: $first) {
      data {
        id
        first_name
        last_name
        full_name
      }
    }
  }
`

export const SearchContractors = gql`
  query SearchContractors($search: String, $site_id: ID, $page: Int = 1) {
    contractors(search: $search, site_id: $site_id, page: $page) {
      data {
        id
        first_name
        last_name
        full_name
        is_contractor
        date_of_birth
        companies {
          id
          name
        }
        inductions {
          id
          site_id
          on_site_training_done
          completed_at
        }
      }

      paginatorInfo {
        currentPage
        lastPage
        hasMorePages
      }
    }
  }
`

export const SearchManager = gql`
  query SearchInputManagers($search: String, $page: Int = 1, $first: Int = 50) {
    siteManagers(search: $search, page: $page, first: $first) {
      data {
        id
        first_name
        last_name
        full_name
      }
    }
  }
`
